import { Box, Typography } from "@mui/material";
import projects from "./projects";
import ProjectCard from "./ProjectCard";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { useEffect, useMemo } from "react";
import mentoPng from "./logos/mento.png";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

// import array of Project objects from projects.json

const App = () => {
  const isGamesPage = useMemo(() => window.location.href.includes("games"), []);

  const filteredProjects = useMemo(() => {
    // if current URL contains "games", filter projects to only include those with "game" in their tags

    if (isGamesPage) {
      return projects.filter((project) => project.tags?.includes("game"));
    }

    return projects;
  }, [isGamesPage]);

  useEffect(() => {
    if (!isGamesPage) {
      document.title = "My Projects";
    }
  }, [isGamesPage]);
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
          maxWidth: 600,
          margin: "auto",
          p: {
            xs: 1,
            sm: 2,
          },
          boxSizing: "border-box",
        }}
      >
        {isGamesPage && (
          <Typography
            variant="h4"
            component="h1"
            sx={{ mb: 1, fontWeight: 600 }}
          >
            Mento Games
          </Typography>
        )}
        {filteredProjects.map((project) => (
          <ProjectCard key={project.url} project={project} />
        ))}
      </Box>
      {isGamesPage && (
        <Box
          component="a"
          href="https://mento.co.uk"
          target="_blank"
          title="Mento Apps Ltd"
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            display: "block",
            lineHeight: 0,
          }}
        >
          <Box
            component="img"
            src={mentoPng}
            alt="Mento Logo"
            sx={{
              width: 50,
              height: 50,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </Box>
      )}
    </ThemeProvider>
  );
};

export default App;
